export const FAILED = 'SetupAuthenticator/failed';
export const LOADING = 'SetupAuthenticator/loading';
export const SUCCESS = 'SetupAuthenticator/success';
